import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const divStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  flexDirection: 'column',
  width: '100%',
  height: '100vh',
  gap: 20,
  marginTop: 200,
} as React.CSSProperties;

const Error = () => {
  return (
    <div style={divStyles}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h1 style={{ color: 'white', margin: 0 }}>
          Sorry this page isn't available.
        </h1>
        <h4 style={{ color: 'white', marginTop: '10px' }}>
          The link you came to might be broken or removed
        </h4>
      </div>
      <Button
        sx={{
          backgroundColor: '#ddb930',
          textTransform: 'capitalize',
          borderRadius: '10px',
          padding: '10px 15px',
        }}
      >
        <Link
          style={{ textDecoration: 'none', color: 'white', fontWeight: 600 }}
          to="/"
        >
          Go back to home
        </Link>
      </Button>
    </div>
  );
};

export default Error;
